var $4c9dcf87f189563f$exports = {};
$4c9dcf87f189563f$exports = {
  "backButton": args => "Povratak na ".concat(args.prevMenuButton),
  "moreActions": "Dodatne radnje",
  "unavailable": "Nije dostupno, pro\u0161iri za detalje"
};
export { $4c9dcf87f189563f$exports as default };